import PropTypes from 'prop-types';
import { Component } from 'react';
import EPPreviewIframe from 'editor-components/preview/EPPreviewIframe';
import { MOBILE, TABLET, DESKTOP } from './internal/constants';
import { View } from 'foundations-components/components/View';
import { DeviceFrame } from 'foundations-components/transitional/components/DeviceFrame';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
function computeDeviceStyles(device, getDeviceStyles) {
  let baseStyles = {};
  if (device === DESKTOP) {
    baseStyles = {
      maxInlineSize: '1200px',
      inlineSize: '100%',
      blockSize: '723px'
    };
  } else if (device === TABLET) {
    baseStyles = {
      inlineSize: '826px',
      blockSize: '1024px'
    };
  } else if (device === MOBILE) {
    baseStyles = {
      inlineSize: '520px'
    };
  }
  if (!getDeviceStyles) {
    return baseStyles;
  }
  return Object.assign(baseStyles, getDeviceStyles(device));
}
class EPPreviewDevices extends Component {
  render() {
    const {
      devices,
      previewUrl,
      deviceHeader,
      getDeviceStyles
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      marginBlockEnd: "1000",
      "data-selenium": "preview-devices",
      id: "ep-preview-devices",
      padding: "500",
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        flexWrap: "wrap",
        alignItems: "start",
        blockSize: "100%",
        children: devices.map(device => {
          return /*#__PURE__*/_jsx(DeviceFrame, Object.assign({
            // @ts-expect-error Custom breakapoints aren't supported yet so we are still good to use this component
            type: device,
            marginBlockEnd: "1000",
            marginInlineStart: "1000",
            marginBlockStart: "200"
          }, computeDeviceStyles(device, getDeviceStyles), {
            children: /*#__PURE__*/_jsx(EPPreviewIframe, {
              previewUrl: previewUrl,
              deviceHeader: deviceHeader,
              "data-test-id": `ep-preview-device-frame-${device}`
            }, `${device}-${previewUrl}`)
          }), typeof device === 'string' ? device : device.name);
        })
      })
    });
  }
}
EPPreviewDevices.propTypes = {
  previewUrl: PropTypes.string.isRequired,
  deviceHeader: PropTypes.node,
  devices: PropTypes.array,
  getDeviceStyles: PropTypes.func
};
EPPreviewDevices.defaultProps = {
  devices: [MOBILE, TABLET]
};
export default EPPreviewDevices;